
import { Check, Lock } from "lucide-react";

const PaymentFooter = () => {
  return (
    <>
      <div className="mt-6 pt-6 border-t border-gray-100">
        <div className="flex items-center justify-between text-sm text-gray-500">
          <div className="flex items-center gap-1">
            <Lock className="h-4 w-4" />
            Secure payment
          </div>
          <p>Cancel any time. Or change you plan later.</p>
        </div>
      </div>

      <div className="text-center space-y-2">
        <p className="text-sm text-gray-500">
          By completing this purchase, you agree to our Terms of Service
        </p>
        <div className="flex items-center justify-center gap-4 text-sm">
          <Check className="h-4 w-4 text-green-500" />
          <span className="text-green-600">30-day money-back guarantee</span>
        </div>
      </div>
    </>
  );
};

export default PaymentFooter;
